<template>
  <div data-test="save-filter-modal-desktop">
    <mc-modal :heading="$t('filter.button.save.label')" :open="showSaveFilterModal" @closed="modalToggle(false)">
      <mc-input
        id="filterNameInput"
        :label="$t('filter.name')"
        required="true"
        :invalid="saveError"
        :errormessage="errorMessage"
        :value="filterName"
        maxlength="30"
        @input="updateFilterName"
      />

      <span class="mb-2 mt-4">{{ $t("filter.conditions") }}</span>
      <div v-for="(filter, index) in activeFilter" :key="index" class="d-inline mb-2">
        <span class="mds-text--medium-bold"> {{ toTitleCase(filter.label) }}: </span>
        <span class="ml-1"> {{ filter.value }}</span>
      </div>
      <mc-button
        slot="primaryAction"
        data-test="save-filter-button"
        :disabled="saveDisabled"
        appearance="primary"
        :label="!saveDisabled ? $t('filter.button.save.label') : $t('filter.button.saving.label')"
        @click="saveSelectedFilter()"
      />
      <mc-button
        slot="secondaryAction"
        data-test="save-filter-button-cancel"
        appearance="neutral"
        :label="$t('common.cancel')"
        dialogaction="cancel"
        @click="modalToggle(false)"
      />
    </mc-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { filters } from "@/store/filters";
import emitter from "tiny-emitter/instance";
import { toTitleCase } from "@/lib/filters";
import { getExportImportPage } from "@/lib/utilities";

export default {
  name: "SaveFilter",
  data() {
    return {
      showSaveFilterModal: false,
      saveError: false,
      errorMessage: "",
      filterName: "",
      saveDisabled: false
    };
  },
  computed: {
    ...mapState(filters, [
      "selectedVessel",
      "selectedFromLocation",
      "selectedToLocation",
      "selectedRole",
      "activeFilter",
      "savedFilters"
    ])
  },
  async mounted() {
    emitter.on("save-filter-modal-desktop", this.modalToggle);
  },
  methods: {
    ...mapActions(filters, ["saveFilter", "getSavedFilters"]),
    toTitleCase,
    modalToggle(value) {
      this.showSaveFilterModal = value;
    },
    updateFilterName($event) {
      this.filterName = $event.target.value;
    },
    async saveSelectedFilter() {
      if (!this.savedFilters?.length) {
        await this.getSavedFilters();
      }
      this.saveError = false;
      if (!this.filterName?.trim()) {
        this.errorMessage = this.errors().empty;
        this.saveError = true;
      } else if (this.savedFilters?.length >= 20) {
        this.errorMessage = this.errors().limit;
        this.saveError = true;
      } else if (this.savedFilters.find((f) => f.filterName === this.filterName)) {
        this.errorMessage = this.errors().name;
        this.saveError = true;
      } else {
        this.saveDisabled = true;
        try {
          await this.saveFilter(this.filterName);
          this.saveError = false;
          this.saveDisabled = false;
          this.showSaveFilterModal = false;
          this.sendGA();
        } catch (e) {
          this.saveError = true;
          this.errorMessage = this.errors().server;
          this.saveDisabled = false;
        }
      }
    },
    errors() {
      return {
        name: this.$t("filter.error.exists"),
        server: this.$t("filter.error.unableToSave"),
        limit: this.$t("filter.error.exceeded"),
        empty: this.$t("filter.error.emptyName")
      };
    },
    sendGA() {
      this.$sendGAEvent({
        event: "DQCS",
        action: "Click",
        category: "SO_FilterSave",
        label: {
          data: `${getExportImportPage()} Shipment filter save`,
          from: this.selectedFromLocation.label,
          to: this.selectedToLocation.label,
          vessel: this.selectedVessel.label,
          role: this.selectedRole
        }
      });
    }
  }
};
</script>
